
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../../../environment/Apiurl";
import PharmacyInvoiceTemplate from "./PharmacyInvoiceTemplate";

const SalesBill = () => {
  const { invoice_number } = useParams();
  const [salePharmacyData, setSalePharmacyData] = useState(null);
  const [stockData, setStockData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [printed, setPrinted] = useState(false);
  const [hasPrinted, setHasPrinted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (invoice_number) {
      fetchSalePharmacyData();
      fetchStockData();
    }
  }, [invoice_number]);

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!loading && !error && salePharmacyData && !hasPrinted) {
      const timeout = setTimeout(() => {
        setHasPrinted(true);

        // Set up event listener before calling print
        const afterPrint = () => {
          window.removeEventListener('afterprint', afterPrint);
          window.close(); // Close popup and return to parent window
        };

        window.addEventListener('afterprint', afterPrint);

        // Trigger print dialog
        window.print();

      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [loading, error, salePharmacyData, hasPrinted]);


  const fetchSalePharmacyData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Apiurl}/sale_pharmacy?invoice_number=${invoice_number}`
      );

      console.log("Sale Pharmacy API Response:", response.data);

      let data = response.data;
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data.data) {
        data = response.data.data;
      } else if (response.data) {
        data = response.data;
      } else {
        throw new Error("Unexpected API response structure");
      }

      const filteredData = Array.isArray(data)
        ? data.find((item) => item.invoice_number === invoice_number)
        : data.invoice_number === invoice_number
          ? data
          : null;

      if (filteredData) {
        console.log("Filtered Sale Data:", filteredData);
        setSalePharmacyData(filteredData);
      } else {
        setError(`No data found for invoice_number: ${invoice_number}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError(`Failed to fetch invoice data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchStockData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/stock_pharmacy`);
      console.log("Stock Data:", response.data);
      setStockData(response.data || []);
    } catch (error) {
      console.error("Error fetching stock data:", error.message);
      setError(`Failed to fetch stock data: ${error.message}`);
    }
  };

  // const getMedicineName = (medicine_id, batch_no) => {
  //   const stockItem = stockData.find(
  //     (item) => item.medicine_id === medicine_id && item.batch_no === batch_no
  //   );
  //   return stockItem?.medicine_details[0]?.medicine_name || "Unknown Medicine";
  // };

  const getMedicineName = (medicine_id, batch_no) => {
    console.log("=== getMedicineName Debug ===");
    console.log("Looking for medicine_id:", medicine_id);
    console.log("Looking for batch_no:", batch_no);
    console.log("stockData length:", stockData.length);
    console.log("stockData:", stockData);

    const stockItem = stockData.find(
      (item) => {
        console.log("Checking item:", item);
        console.log("item.medicine_id:", item.medicine_id);
        console.log("item.batch_no:", item.batch_no);
        console.log("Medicine ID match:", item.medicine_id === medicine_id);
        console.log("Batch No match:", item.batch_no === batch_no);
        return item.medicine_id === medicine_id && item.batch_no === batch_no;
      }
    );

    console.log("Found stockItem:", stockItem);

    if (stockItem?.medicine_details) {
      console.log("medicine_details:", stockItem.medicine_details);
      console.log("Is array?", Array.isArray(stockItem.medicine_details));

      if (Array.isArray(stockItem.medicine_details)) {
        const name = stockItem.medicine_details[0]?.medicine_name;
        console.log("Medicine name from array:", name);
        return name || "Unknown Medicine";
      } else {
        const name = stockItem.medicine_details.medicine_name;
        console.log("Medicine name from object:", name);
        return name || "Unknown Medicine";
      }
    }

    console.log("No medicine_details found, returning Unknown Medicine");
    return "Unknown Medicine";
  };

  // Function to get tax (GST percentage) from stock data
  const getMedicineTax = (medicine_id, batch_no) => {
    const stockItem = stockData.find(
      (item) => item.medicine_id === medicine_id && item.batch_no === batch_no
    );
    // Check for either gst_percentage or tax field
    return stockItem
      ? parseFloat(stockItem.gst_percentage || stockItem.tax || 0).toFixed(2)
      : "0.00";
  };

  const seller = {
    name: "4Health Homeopathy",
    address:
  "Ground Floor, Sixer Complex, Saradha College Road, Salem - 636007.",
phone: "+91 99448 44408",
    email: "",
    gstin: "33AAVFJ7968F1ZO",
    dlNo: "TN/SLW/21/01156",
  };

  const buyer = salePharmacyData
    ? {
      his_no: salePharmacyData.patient_details?.[0]?.patient_id || "N/A",
      name:
        `${salePharmacyData.patient_details?.[0]?.first_name || ""} ${salePharmacyData.patient_details?.[0]?.last_name || ""
          }`.trim() || "N/A",
      address:
        `${salePharmacyData.patient_details?.[0]?.address || ""}, ${salePharmacyData.patient_details?.[0]?.city || ""
          }, ${salePharmacyData.patient_details?.[0]?.state || ""} - ${salePharmacyData.patient_details?.[0]?.pincode || ""
          }`.trim() || "N/A",
      phone: salePharmacyData.patient_details?.[0]?.mobile_no || "N/A",
      gstin: "",
      dlNo: "",
    }
    : {
      name: "",
      address: "",
      phone: "",
      gstin: "",
      dlNo: "",
    };

  const invoice = salePharmacyData
    ? {
      no: salePharmacyData.invoice_number || "",
      date: salePharmacyData.sale_date
        ? new Date(salePharmacyData.sale_date).toLocaleDateString("en-GB")
        : "",
      dueDate: salePharmacyData.sale_date
        ? new Date(salePharmacyData.sale_date).toLocaleDateString("en-GB")
        : "",
      refNo: "",
      note: salePharmacyData.notes || "",
      payments_types: salePharmacyData.payment_type || "",
      billedBy: salePharmacyData.created_by || "N/A",
    }
    : {
      no: "",
      date: "",
      dueDate: "",
      refNo: "",
      note: "",
      payments_types: "",
      billedBy: "",
    };

  // const items =
  //   salePharmacyData?.sales_list?.map((item, index) => {
  //     console.log("Item in sales_list:", item);
  //     return {
  //       sr: index + 1,
  //       hsn: item.hsn_code || "N/A",
  //       description: getMedicineName(item.medicine_id, item.batch_no),
  //       pack: "",
  //       mfr: "",
  //       batchNo: item.batch_no || "",
  //       expDt: item.expiry_date
  //         ? new Date(item.expiry_date).toLocaleDateString("en-GB")
  //         : "",
  //       qty: parseInt(item.quantity) || 0,
  //       free: 0,
  //       mrp: parseFloat(item.mrp || 0).toFixed(2),
  //       rate: parseFloat(item.mrp || 0).toFixed(2),
  //       dis: parseFloat(salePharmacyData.discount_percentage || 0).toFixed(2),
  //       gst: getMedicineTax(item.medicine_id, item.batch_no), // Use getMedicineTax for consistent GST percentage
  //       amount: parseFloat(item.total || 0).toFixed(2),
  //     };
  //   }) || [];

  const items =
    salePharmacyData?.sales_list?.map((item, index) => {
      console.log("Item in sales_list:", item);

      // Get medicine name directly from the item's medicine_details
      const medicineName =
  item.medicine_name ||
  item.medicine_details?.medicine_name ||
  item.medicine_details?.[0]?.medicine_name ||
  "Unknown Medicine";

      return {
        sr: index + 1,
        hsn: item.hsn_code || "N/A",
        description: medicineName, // Use the medicine name directly
        pack: "",
        mfr: "",
        batchNo: item.batch_no || "",
        expDt: item.expiry_date
          ? new Date(item.expiry_date).toLocaleDateString("en-GB")
          : "",
        qty: parseInt(item.quantity) || 0,
        free: 0,
        mrp: parseFloat(item.mrp || 0).toFixed(2),
        rate: parseFloat(item.mrp || 0).toFixed(2),
        dis: parseFloat(salePharmacyData.discount_percentage || 0).toFixed(2),
        gst: item.gst_percentage || item.tax || "0.00", // Also get GST directly from item
        amount: parseFloat(item.total || 0).toFixed(2),
      };
    }) || [];

  const taxDetails = salePharmacyData
    ? salePharmacyData.sales_list
      ?.reduce((acc, item) => {
        console.log("Processing taxDetails for item:", item);
        const gst = parseFloat(item.tax || item.gst_percentage || 0);
        const quantity = parseInt(item.quantity) || 0;
        const mrp = parseFloat(item.mrp) || 0;
        const base_price = mrp / (1 + gst / 100); // Calculate base price excluding GST
        const taxable = quantity * base_price; // Taxable amount = quantity * base price
        const tax = parseFloat(item.tax_row_value) || 0;
        const sgst = salePharmacyData.apply_gst ? tax / 2 : 0;
        const cgst = salePharmacyData.apply_gst ? tax / 2 : 0;

        const existing = acc.find((t) => t.gst === gst);
        if (existing) {
          existing.taxable += taxable;
          existing.tax += tax;
          existing.sgst += sgst;
          existing.cgst += cgst;
        } else {
          acc.push({ gst, taxable, tax, sgst, cgst });
        }
        return acc;
      }, [])
      .sort((a, b) => a.gst - b.gst)
      .map((t) => ({
        gst: `${t.gst.toFixed(2)}%`,
        taxable: t.taxable.toFixed(2),
        tax: t.tax.toFixed(2),
        sgst: t.sgst.toFixed(2),
        cgst: t.cgst.toFixed(2),
      }))
    : [];

  const footerData = salePharmacyData
    ? {
      bank: {
        bankName: "",
        accountNo: "",
        ifsc: "",
        terms: "Thank you for your business.",
      },
      taxDetails,
      totals: {
        subtotal: parseFloat(salePharmacyData.sub_total || 0).toFixed(2),
        discount: parseFloat(salePharmacyData.discount_value || 0).toFixed(2),
        cgstIgst: salePharmacyData.apply_gst
          ? parseFloat(salePharmacyData.gst_amount || 0) / 2
          : 0,
        sgst: salePharmacyData.apply_gst
          ? parseFloat(salePharmacyData.gst_amount || 0) / 2
          : 0,
        roundOff: parseFloat(salePharmacyData.round_off || 0).toFixed(2),
        netAmount: parseFloat(salePharmacyData.net_total || 0).toFixed(2),
        totalQty:
          salePharmacyData.sales_list?.reduce(
            (sum, item) => sum + (parseInt(item.quantity) || 0),
            0
          ) || 0,
        page: "Page 1 of 1",
      },
    }
    : {
      bank: {
        bankName: "",
        accountNo: "",
        ifsc: "",
        terms: "",
      },
      taxDetails: [],
      totals: {
        subtotal: 0,
        discount: 0,
        cgstIgst: 0,
        sgst: 0,
        roundOff: 0,
        netAmount: 0,
        totalQty: 0,
        page: "Page 1 of 1",
      },
    };

  function numberToWords(num) {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if ((num = num.toString()).length > 9) return "Overflow";
    const n = ("000000000" + num)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{3})$/);
    if (!n) return "";

    let str = "";
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + " Crore "
        : "";
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + " Lakh "
        : "";
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + " Thousand "
        : "";

    let lastPart = "";
    const hundreds = Math.floor(n[4] / 100);
    const tens = n[4] % 100;

    if (hundreds > 0) {
      lastPart += a[hundreds] + " Hundred";
      if (tens > 0) lastPart += " and ";
    }

    if (tens > 0) {
      lastPart += a[tens] || b[Math.floor(tens / 10)] + " " + a[tens % 10];
    }

    str += lastPart;
    return str.trim() + " Only";
  }

  const amountInWords = numberToWords(Math.round(footerData.totals.netAmount));

  if (loading) return <div className="text-center">Loading...</div>;
  if (error) return <div className="text-danger text-center">{error}</div>;
  if (!salePharmacyData)
    return (
      <div className="text-center">
        No data found for invoice {invoice_number}
      </div>
    );

  return (
    <PharmacyInvoiceTemplate
      seller={seller}
      buyer={buyer}
      invoice={invoice}
      items={items}
      footerData={footerData}
      amountInWords={amountInWords}
    />
  );
};

export default SalesBill;
